import request from '@/utils/request'

let PartnerApi = {
    /*列表*/
    getMean(data) {
        return request._get('/shop/plus.partner.mean/index', data);
    },
    /*添加*/
    meanDetail(data) {
        return request._get('/shop/plus.partner.mean/edit', data);
    },
    /*列表*/
    getContribution(data) {
        return request._get('/shop/plus.partner.contribution/index', data);
    },
    /*添加*/
    contributionDetail(data) {
        return request._get('/shop/plus.partner.contribution/edit', data);
    },
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.partner.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.partner.setting/index', data);
    },

}

export default PartnerApi;



// WEBPACK FOOTER //
// ./src/api/partner.js